import Chapter from "@/components/Chapter";
import Reveal from "@/components/Reveal";
import { GALLERY } from "@/data/content";

const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="bg-white py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Chapter
        index="06"
        eyebrow="Inside the Mill"
        title="Looms, dye houses and despatch."
      />
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {GALLERY.map((g, i) => (
          <Reveal key={g.caption} delay={(i % 3) * 0.08}>
            <figure data-testid={`gallery-item-${i}`} className="group">
              <div className="relative aspect-[4/3] overflow-hidden bg-navy">
                <img
                  data-testid={`gallery-image-${i}`}
                  src={g.src}
                  alt={g.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  onError={(e) => (e.currentTarget.style.opacity = 0)}
                />
                <div className="absolute inset-0 bg-navy/0 transition-colors duration-500 group-hover:bg-navy/15" />
              </div>
              <figcaption className="mt-3 flex items-baseline gap-3">
                <span className="font-serif text-xs italic text-gold">{String(i + 1).padStart(2, "0")}</span>
                <span className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{g.caption}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
